<template>
    <q-card flat bordered>
        <q-card-section
            class="q-pa-sm row items-center bg-primary text-white text-bold"
        >
            Quote Report
            <q-btn icon="attach_money" class="q-ml-xs" flat round dense size="xs">
            <q-tooltip anchor="center right" self="center left" :offset="[10, 10]">
                <strong>{{basePriceText}}</strong>
            </q-tooltip>
            </q-btn>
        </q-card-section>
        <q-separator />
        <q-card-section>
            <q-scroll-area style="height: 100px">
            <div v-if="eventToReport">
                <p
                class="q-mb-sm"
                style="font-size: 14px"
                >
                {{ eventToReport.eventDate | usDateFormat }}
                {{ eventToReport.description }}
                </p>
            </div>
            </q-scroll-area>
        </q-card-section>
    </q-card>
</template>

<script>

export default {
  name: 'AppQuoteReportCard',
  props: {
    basePriceText: {
      type: String,
      default: ''
    },
    eventToReport: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {

    };
  },
  computed: {

  },

  methods: {

  }
};
</script>
